import {AppConfig, AppJson, AppManifest, View, RouteJson} from './types/App';
import * as fse from 'fs-extra';
//import {outputDir} from './config';
import * as colors from 'colors';
import {Log, LogLn} from './Util';

// @dynamic
export class FileAPI {
    static destDir: string;

    static inputRoot: string = '';

    static enableLogging = true;

    //////////////////////////////////////////////////////////
    // check the output directory, copy the skeleton if needed
    //////////////////////////////////////////////////////////
    static prepareSkeleton(app: AppJson, create_new_project: boolean): void {
        if (fse.pathExistsSync(this.destDir) && create_new_project) {
            Log(`App folder ${this.destDir} exists. Deleting src/ subfolder...`);
            fse.emptyDirSync(`${this.destDir}/src`);
            LogLn('[success]');
        }

        fse.ensureDirSync(this.destDir);
        Log(`Copying skeleton dir ./skeleton => ${this.destDir}..\t\t`);
        fse.copySync('./skeleton', this.destDir);
        LogLn('[success]');
    }

    static serveNg() {
        /*// On Windows Only ...
        const {spawn} = import('child_process');
        const bat = spawn('cmd.exe', ['c:\\Web\\Magic\\TemplateFactory\\output\\test\\ng', 'serve']);

        bat.stdout.on('data', (data) => {
            LogLn(data.toString());
        });

        bat.stderr.on('data', (data) => {
            LogLn(data.toString());
        });

        bat.on('exit', (code) => {
            LogLn(`Child exited with code ${code}`);
        });*/

    }

    //////////////////////////////////////////////////////////
    // read the view json file
    //////////////////////////////////////////////////////////
    static readInputJson( magic_config: AppConfig): AppJson {

      console.dir(magic_config);

        let app: AppJson = {name: magic_config.project_name, suffix: "mga", views: []};
        magic_config.form_files.forEach((file: string) => {
            Log(`Loading json file ${file + '.json'}...\t\t`);
            app.views.push(<View>fse.readJsonSync( this.inputRoot + file + '.json', {encoding: 'utf8'}));
            LogLn(colors.green('[success]'));
        });
        return app;
    };

    static readRouteJson(): RouteJson {
        let routeJson = fse.readJsonSync(this.inputRoot + 'routes' + '.json');
        return routeJson;
    }

    //////////////////////////////////////////////////////////
    // read the view json file as a single control
    //////////////////////////////////////////////////////////
    static readInputJsonAsView(): View {

        const view = <View>fse.readJsonSync(this.inputRoot + 'control.json', {encoding: "utf8"});

        return view;
    };

    //////////////////////////////////////////////////////////
    // read the config json file
    //////////////////////////////////////////////////////////
    static readInputConfig(): AppConfig {

        const
            file = 'config.json';

        if (this.enableLogging)
            Log(`Loading config file: ${this.inputRoot + file}...\t\t`);
        // read the file into the app - Should create an AppConfig object
        const app = <AppConfig>fse.readJsonSync(this.inputRoot + file, {encoding: 'utf8'});
        if (this.enableLogging)
            LogLn(colors.green('[success]'));

        return app;
    };

    //////////////////////////////////////////////////////////
    // copy the applicatio css file to the output
    //////////////////////////////////////////////////////////
    static copyCssFile() {
        LogLn("Copy CSS file");
        fse.copySync(this.inputRoot + "application-styles.css", this.destDir + "/src/application-styles.css");
    }

    //////////////////////////////////////////////////////////
    // read the image directory
    //////////////////////////////////////////////////////////
    static copyImages(config: AppConfig): void {
        if (config.copy_images && config.source_images_folder && config.source_images_folder.length > 0 && fse.pathExistsSync(config.source_images_folder)) {
            LogLn("Copy images");
            fse.copySync(config.source_images_folder + "/", this.destDir + "/src/assets/images/");
        }
        else
            LogLn("Skip images copy");
    }

    //////////////////////////////////////////////////////////
    // read the old manifest file, if exists
    //////////////////////////////////////////////////////////
    static getOldManifest(config: AppConfig, appName: string): AppManifest {
        const oldManifestFile = this.GetManifestFileName(appName);
        if (!config.create_new_project && fse.pathExistsSync(oldManifestFile)) {
            LogLn("Reading old manifest file");
            const manifest = <AppManifest>fse.readJsonSync(oldManifestFile, {encoding: 'utf8'});

            return manifest;
        }
        else {
            LogLn("No manifest file found");

            let myObj: AppManifest = {components: []};
            return myObj;
        }
    }

    //////////////////////////////////////////////////////////
    // write the new manifest file
    //////////////////////////////////////////////////////////
    static WriteManifest(manifest: AppManifest, appName: string): void {
        LogLn("Writing new manifest file");
        const manifestFile = this.GetManifestFileName(appName);
        //use nice formatting - not fse.writeJsonSync(manifestFile, manifest);
        fse.writeFileSync(manifestFile, JSON.stringify(manifest, null, 2));
    }

    //////////////////////////////////////////////////////////
    // build the manifest file name
    //////////////////////////////////////////////////////////
    static GetManifestFileName(appName: string): string {
        return this.destDir + "/src/" + appName + ".manifest";
    }

    //////////////////////////////////////////////////////////
    // copy the app.module files
    //////////////////////////////////////////////////////////
    static CopyAppModuleFiles(theme: string) {
       fse.copySync('src/templates/angular/src/app.module.ts', this.destDir + '/src/app/app.module.ts');
       fse.copySync('src/templates/angular/src/app.component.ts', this.destDir + '/src/app/app.component.ts');
       //fse.copySync('src/templates/themes/' + theme + '/Code', this.destDir + '/src/app/magic/src/ui/theme');
        //fse.copySync('src/templates/themes/table/TextEditDialog', this.destDir + '/src/app/magic/src/ui/TextEditDialog');
    }
}
